import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize'
    // TODO: Once @Injectable is removed, add pure: true to ensure the pipe is only called when the input value changes.
    ,
    standalone: false
})
@Injectable({ providedIn: 'root' }) // TODO: Pipes should be pure, stateless and not injectable. Refactor to a service if caching or dependencies are needed.
// TODO: Consider renaming FormatDisplayTextPipe or similar to better reflect its purpose and avoid confusion with a generic "capitalize" function.
export class CapitalizePipe implements PipeTransform {

  // Words that should not be capitalized
  private readonly EXCLUSIONS = new Set(['P&S', 'WW', '(GC)', 'CO\u2082e', 'AquaIQ']);

  // Special Case Transformations
  private readonly TRANSFORMATIONS: Record<string, string> = {
    'CO2e': 'CO₂e'
  };

  transform(value: string): string {
    if (!value) return '';

    return value
      .split(' ')
      .map(word => this.capitalizeWord(word))
      .join(' ');
  }

  private capitalizeWord(word: string): string {
    // Handle special transformations first
    if (this.TRANSFORMATIONS[word]) {
      return this.TRANSFORMATIONS[word];
    }

    // Skip exclusions
    if (this.EXCLUSIONS.has(word)) {
      return word;
    }

    // Skip words starting with numbers
    if (/^\d/.test(word)) {
      return word;
    }

    // Handle empty or single character words
    if (word.length <= 1) {
      return word.toUpperCase();
    }

    // Capitalize words starting with special characters (e.g., parentheses)
    if (/^[^\w]/.test(word)) {
      return word[0] + word.slice(1).toLowerCase().replace(/^\w/, c => c.toUpperCase());
    }

    // Default: capitalize first letter, lowercase rest
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }
}
